import styled from 'styled-components'

import { mq, sizes } from '../../theme'

type StyledProps = {
  backgroundColor?: string
}
export const Container = styled.section<StyledProps>`
  position: relative;
  padding-top: 3rem;
  padding-bottom: 3rem;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ? backgroundColor : theme.colors.greyf5 ?? 'lightgrey'};
  @media ${mq(sizes.desktop)} {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  & + & {
    padding-top: 1px; // safety to prevent inside element's margin to create a space
  }
`
export const Wrapper = styled.div`
  max-width: ${({ theme }) =>
    `calc(${theme.sizes.boxContent / 10}rem + 8rem + 8rem)`};
  margin-left: auto;
  margin-right: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  &:not(:first-child) {
    margin-top: 3rem;
  }
  @media ${mq(sizes.desktop)} {
    padding-left: 8rem;
    padding-right: 8rem;
    &:not(:first-child) {
      margin-top: 6rem;
    }
  }
`
